var map = {
	"./0-2.jpg": 54389,
	"./12-18.jpg": 47338,
	"./2-11.jpg": 41031,
	"./Banner-2.jpg": 70755,
	"./Banner-Introduccion.jpg": 4127,
	"./Banner-Nuevo-01.png": 28143,
	"./Banner-Nuevo-02.png": 45949,
	"./Banner-Nuevo-03.png": 9194,
	"./Banner-Nuevo-05.png": 61626,
	"./Banner-Scorad.jpg": 14394,
	"./Banner-ScoradOLD.jpg": 40576,
	"./Banner-bibliografia.jpg": 10350,
	"./Banner-dermatitis.png": 31371,
	"./Banner-sintomas.jpg": 34019,
	"./Banner.jpg": 11150,
	"./Calculadora.png": 31749,
	"./Carita-Feliz.png": 59294,
	"./Carita-Triste.png": 67764,
	"./Cuello-001.png": 4379,
	"./Cuello-01.png": 85962,
	"./Descargar-PDF.png": 59778,
	"./Edema-Elevacion-0.png": 43432,
	"./Edema-Elevacion-1.png": 82188,
	"./Edema-Elevacion-2.png": 66870,
	"./Edema-Elevacion-3.png": 90666,
	"./Encuesta-HADS.jpg": 29187,
	"./Encuesta-HADS.png": 12887,
	"./Enviar-correo.png": 18705,
	"./Eritema-0.png": 48917,
	"./Eritema-1.png": 94258,
	"./Eritema-2.png": 3731,
	"./Eritema-3.png": 83689,
	"./Escala-ADCT.png": 74383,
	"./Escala-DLQI.jpg": 90752,
	"./Escala-DLQI.png": 58726,
	"./Escala-DLQIOLD.jpg": 2329,
	"./Escala-EASI.jpg": 5,
	"./Escala-EASI.png": 46705,
	"./Escala-POEM.jpg": 81381,
	"./Escala-POEM.png": 51293,
	"./Espalda-001.png": 76273,
	"./Espalda-01.png": 1751,
	"./Excoriaciones-0.png": 71373,
	"./Excoriaciones-1.png": 98958,
	"./Excoriaciones-2.png": 37430,
	"./Excoriaciones-3.png": 85725,
	"./Exudados-Costras-0.png": 64284,
	"./Exudados-Costras-1.png": 167,
	"./Exudados-Costras-2.png": 58173,
	"./Exudados-Costras-3.png": 66928,
	"./Fondo.png": 96539,
	"./Hombre.png": 82426,
	"./Hombre/Atras.jpg": 82004,
	"./Hombre/Brazos-Espalda.jpg": 41155,
	"./Hombre/Brazos-Posterior.jpg": 77205,
	"./Hombre/Brazos-Torso.jpg": 24833,
	"./Hombre/Brazos-pierna-derecha.jpg": 65011,
	"./Hombre/Brazos-pierna-izquierda.jpg": 85129,
	"./Hombre/Cabeza-Brazo-Derecho.jpg": 6690,
	"./Hombre/Cabeza-Brazo-Izquierdo.jpg": 77751,
	"./Hombre/Cabeza-Brazos-Pierna-Derecha.jpg": 55370,
	"./Hombre/Cabeza-Brazos-Pierna-Izquierda.jpg": 17046,
	"./Hombre/Cabeza-Brazos-Piernas.jpg": 48977,
	"./Hombre/Cabeza-Brazos.jpg": 21666,
	"./Hombre/Espalda-Piernas-Posterior.jpg": 15084,
	"./Hombre/Espalda.jpg": 51325,
	"./Hombre/Frente.jpg": 69525,
	"./Hombre/Pene-Hombre.jpg": 99323,
	"./Hombre/Piernas-Posterior.jpg": 4655,
	"./Ingresar-paciente.jpg": 98764,
	"./Ir-a-historico.png": 39348,
	"./Liquenificacion-0.png": 19705,
	"./Liquenificacion-1.png": 40474,
	"./Liquenificacion-2.png": 68348,
	"./Liquenificacion-3.png": 34740,
	"./Logo-Crear-Imagen.png": 91529,
	"./Logo-Dermatopic.png": 27682,
	"./Mujer.png": 67816,
	"./Mujer/Brazos-Espalda-Posterior.jpg": 87653,
	"./Mujer/Brazos-Posterior.jpg": 87097,
	"./Mujer/Brazos-Torso.png": 17642,
	"./Mujer/Brazos-pierna-derecha.jpg": 66861,
	"./Mujer/Brazos-pierna-izquierda.jpg": 97473,
	"./Mujer/Cabeza-Brazo-Derecho.jpg": 71050,
	"./Mujer/Cabeza-Brazo-Izquierdo.jpg": 45270,
	"./Mujer/Cabeza-Brazos-Pierna-Derecha.jpg": 32061,
	"./Mujer/Cabeza-Brazos-Pierna-Izquierda.jpg": 63958,
	"./Mujer/Cabeza-Brazos-Piernas.jpg": 15295,
	"./Mujer/Cabeza-Brazos.jpg": 43682,
	"./Mujer/Espalda-Piernas-Posterior.jpeg": 8548,
	"./Mujer/Espalda-Posterior.jpg": 66335,
	"./Mujer/Pene-Hombre.jpg": 50746,
	"./Mujer/Vagina-Mujer.png": 20953,
	"./PO-Scorad.jpg": 77988,
	"./PO-Scorad.png": 11705,
	"./Que-es-Dermatitis.jpg": 48648,
	"./Seleccionar-paciente.jpg": 70958,
	"./Tips-EASI.jpg": 96381,
	"./Tips-Scorad.jpg": 61574,
	"./Xerosis-0.png": 65220,
	"./Xerosis-1.png": 27765,
	"./Xerosis-2.png": 88429,
	"./Xerosis-3.png": 94403,
	"./body copy.png": 43707,
	"./bodyhombre/Brazos-001.png": 47033,
	"./bodyhombre/Brazos-002.png": 3198,
	"./bodyhombre/Brazos-01.png": 32929,
	"./bodyhombre/Brazos-02.png": 30997,
	"./bodyhombre/Group 275.png": 18096,
	"./bodyhombre/Hombros-001.png": 45356,
	"./bodyhombre/Hombros-01.png": 42165,
	"./bodyhombre/Manos-001.png": 24304,
	"./bodyhombre/Manos-01.png": 17370,
	"./bodyhombre/Nuca-001.png": 69112,
	"./bodyhombre/Nuca-01.png": 16567,
	"./bodyhombre/Pantorrillas-001.png": 87861,
	"./bodyhombre/Pantorrillas-01.png": 17258,
	"./bodyhombre/Pecho-001.png": 1747,
	"./bodyhombre/Pecho-01.png": 93020,
	"./bodyhombre/Pelvis-001.png": 30584,
	"./bodyhombre/Pelvis-01.png": 4582,
	"./bodyhombre/Persona.jpg": 77532,
	"./bodyhombre/Piernas-001.png": 36958,
	"./bodyhombre/Piernas-01.png": 91938,
	"./bodyhombre/Pies-001.png": 51607,
	"./bodyhombre/Pies-01.png": 31222,
	"./bodyhombre/body.png": 46183,
	"./bodyhombre/bodyNO.png": 99622,
	"./bodyhombre/bodyback copy.png": 57101,
	"./bodyhombre/bodyback.png": 58675,
	"./bodyhombre/bodybase.png": 83770,
	"./bodyhombre/bodybrazoder.png": 58298,
	"./bodyhombre/bodybrazoderpiernader.png": 14249,
	"./bodyhombre/bodybrazoderpiernaizq.png": 79678,
	"./bodyhombre/bodybrazoderpiernas.png": 18537,
	"./bodyhombre/bodybrazoizq.png": 52587,
	"./bodyhombre/bodybrazoizqpiernader.png": 74948,
	"./bodyhombre/bodybrazoizqpiernaizq.png": 92866,
	"./bodyhombre/bodybrazoizqpiernas.png": 41834,
	"./bodyhombre/bodybrazos.png": 91012,
	"./bodyhombre/bodycabeza.png": 655,
	"./bodyhombre/bodycabezacadera.png": 85998,
	"./bodyhombre/bodycabezacaderabrazoder.png": 20875,
	"./bodyhombre/bodycabezacaderabrazoderpiernader.png": 25035,
	"./bodyhombre/bodycabezacaderabrazoderpiernaizq.png": 73635,
	"./bodyhombre/bodycabezacaderabrazoderpiernas.png": 44485,
	"./bodyhombre/bodycabezacaderabrazoizq copy 2.png": 76610,
	"./bodyhombre/bodycabezacaderabrazoizq.png": 10687,
	"./bodyhombre/bodycabezacaderabrazoizqbrazoder.png": 14803,
	"./bodyhombre/bodycabezacaderabrazoizqbrazoderpiernader.png": 78830,
	"./bodyhombre/bodycabezacaderabrazoizqbrazoderpiernaizq.png": 21414,
	"./bodyhombre/bodycabezacaderabrazoizqbrazoderpiernaizqpiernader.png": 34516,
	"./bodyhombre/bodycabezacaderabrazoizqpiernader.png": 84575,
	"./bodyhombre/bodycabezacaderabrazoizqpiernaizq.png": 16074,
	"./bodyhombre/bodycabezacaderabrazoizqpiernas.png": 69135,
	"./bodyhombre/bodycabezacaderapiernader.png": 6286,
	"./bodyhombre/bodycabezacaderapiernaizq.png": 57150,
	"./bodyhombre/bodycabezacaderapiernas.png": 48255,
	"./bodyhombre/bodycabezapiernader.png": 440,
	"./bodyhombre/bodycabezapiernaizq.png": 52354,
	"./bodyhombre/bodycabezapiernas.png": 63521,
	"./bodyhombre/bodycabezatorso.png": 95967,
	"./bodyhombre/bodycabezatorsobrazoder.png": 17326,
	"./bodyhombre/bodycabezatorsobrazoderpiernader.png": 95885,
	"./bodyhombre/bodycabezatorsobrazoderpiernaizq.png": 491,
	"./bodyhombre/bodycabezatorsobrazoderpiernas.png": 45311,
	"./bodyhombre/bodycabezatorsobrazoizq.png": 39798,
	"./bodyhombre/bodycabezatorsobrazoizqpiernader.png": 10889,
	"./bodyhombre/bodycabezatorsobrazoizqpiernaizq.png": 34706,
	"./bodyhombre/bodycabezatorsobrazoizqpiernas.png": 15572,
	"./bodyhombre/bodycabezatorsobrazos.png": 64000,
	"./bodyhombre/bodycabezatorsocadera.png": 66566,
	"./bodyhombre/bodycabezatorsocaderabrazoder.png": 27366,
	"./bodyhombre/bodycabezatorsocaderabrazodermano.png": 34480,
	"./bodyhombre/bodycabezatorsocaderabrazodermanopiernaizq.png": 80446,
	"./bodyhombre/bodycabezatorsocaderabrazoderqmanopiernader.png": 1641,
	"./bodyhombre/bodycabezatorsocaderabrazoizq.png": 33880,
	"./bodyhombre/bodycabezatorsocaderabrazoizqmano.png": 60421,
	"./bodyhombre/bodycabezatorsocaderabrazoizqmanopiernader.png": 1151,
	"./bodyhombre/bodycabezatorsocaderabrazoizqmanopiernaizq.png": 19697,
	"./bodyhombre/bodycabezatorsocaderapiernader.png": 97216,
	"./bodyhombre/bodycabezatorsocaderapiernaizq.png": 78858,
	"./bodyhombre/bodycabezatorsocaderapiernas.png": 71742,
	"./bodyhombre/bodycabezatorsopiernader.png": 97592,
	"./bodyhombre/bodycabezatorsopiernaizq.png": 45995,
	"./bodyhombre/bodycabezatorsopiernas.png": 39063,
	"./bodyhombre/bodycadera.png": 55462,
	"./bodyhombre/bodycaderapiernader.png": 43905,
	"./bodyhombre/bodycaderapiernaizq.png": 60644,
	"./bodyhombre/bodycaderapiernas.png": 19787,
	"./bodyhombre/bodyespalda.png": 25523,
	"./bodyhombre/bodyhombros.png": 2355,
	"./bodyhombre/bodymenosbrazoder.png": 59040,
	"./bodyhombre/bodymenosbrazoizq.png": 11084,
	"./bodyhombre/bodymenoscabeza.png": 32530,
	"./bodyhombre/bodymenospiernader.png": 87510,
	"./bodyhombre/bodymenospiernaizq.png": 46532,
	"./bodyhombre/bodymenospiernas.png": 14337,
	"./bodyhombre/bodymenostorso.png": 28832,
	"./bodyhombre/bodynuca.png": 40400,
	"./bodyhombre/bodynucabrazos.png": 5316,
	"./bodyhombre/bodynucabrazospiernader.png": 54204,
	"./bodyhombre/bodynucabrazospiernaizq.png": 8835,
	"./bodyhombre/bodypiernader.png": 26304,
	"./bodyhombre/bodypiernaizq.png": 58635,
	"./bodyhombre/bodypiernas.png": 27701,
	"./bodyhombre/bodytodo.png": 15576,
	"./bodyhombre/bodytorso.png": 9281,
	"./bodyhombre/brazos.png": 5833,
	"./bodyhombre/brazospelvis.png": 55194,
	"./bodyhombre/brazospelvispiernader.png": 3904,
	"./bodyhombre/brazospelvispiernaizq.png": 36517,
	"./bodyhombre/brazospelvispiernas.png": 31491,
	"./bodyhombre/brazospiernader.png": 24197,
	"./bodyhombre/brazospiernaizq.png": 34266,
	"./bodyhombre/brazosposterior.png": 78965,
	"./bodyhombre/brazostorso.png": 35610,
	"./bodyhombre/brazostorsopiernader.png": 28117,
	"./bodyhombre/brazostorsopiernaizq.png": 35224,
	"./bodyhombre/brazostorsopiernas.png": 9621,
	"./bodyhombre/cabezabrazoder.png": 29706,
	"./bodyhombre/cabezabrazoderpiernader.png": 22957,
	"./bodyhombre/cabezabrazoderpiernaizq.png": 76512,
	"./bodyhombre/cabezabrazoderpiernas.png": 45508,
	"./bodyhombre/cabezabrazoizq.png": 24698,
	"./bodyhombre/cabezabrazoizqpiernader.png": 87941,
	"./bodyhombre/cabezabrazoizqpiernaizq.png": 59047,
	"./bodyhombre/cabezabrazoizqpiernas.png": 53492,
	"./bodyhombre/cabezabrazos.png": 52718,
	"./bodyhombre/cabezabrazospiernader.png": 32337,
	"./bodyhombre/cabezabrazospiernaizq.png": 78873,
	"./bodyhombre/cabezabrazospiernas.png": 87967,
	"./bodyhombre/derechonucaposterior.png": 29479,
	"./bodyhombre/derechoposterior.png": 8205,
	"./bodyhombre/espalda.png": 60040,
	"./bodyhombre/espaldabrazoder.png": 31286,
	"./bodyhombre/espaldabrazoizq.png": 15799,
	"./bodyhombre/espaldabrazos.png": 69511,
	"./bodyhombre/espaldabrazosnuca.png": 10286,
	"./bodyhombre/espaldabrazosnucapiernader.png": 49139,
	"./bodyhombre/espaldabrazosnucapiernaizq.png": 99051,
	"./bodyhombre/espaldapiernader.png": 48023,
	"./bodyhombre/espaldapiernaderbrazoder.png": 47741,
	"./bodyhombre/espaldapiernaderbrazoizq.png": 26265,
	"./bodyhombre/espaldapiernaderbrazoizqbrazoder.png": 92339,
	"./bodyhombre/espaldapiernaizq.png": 51999,
	"./bodyhombre/espaldapiernaizqbrazoder.png": 229,
	"./bodyhombre/espaldapiernaizqbrazoderbrazoizq.png": 61958,
	"./bodyhombre/espaldapiernaizqbrazoizq.png": 36950,
	"./bodyhombre/extremidades.png": 42313,
	"./bodyhombre/extremidadescadera.png": 21246,
	"./bodyhombre/extremidadesposterior.png": 76775,
	"./bodyhombre/extremidadestorso.png": 29302,
	"./bodyhombre/izqnucaposterior.png": 13081,
	"./bodyhombre/izqposterior.png": 81123,
	"./bodyhombre/menoscadera.png": 76585,
	"./bodyhombre/menosnucaposterior.png": 98949,
	"./bodyhombre/pelvisbrazoder.png": 45254,
	"./bodyhombre/pelvisbrazoderpiernader.png": 36089,
	"./bodyhombre/pelvisbrazoderpiernaizq.png": 91022,
	"./bodyhombre/pelvisbrazoderpiernas.png": 1248,
	"./bodyhombre/pelvisbrazoderpiernastorso.png": 36729,
	"./bodyhombre/pelvisbrazoizq.png": 4645,
	"./bodyhombre/pelvisbrazoizqpiernader.png": 28471,
	"./bodyhombre/pelvisbrazoizqpiernaizq.png": 72855,
	"./bodyhombre/pelvisbrazoizqpiernas.png": 93108,
	"./bodyhombre/pelvisbrazoizqpiernastorso.png": 40137,
	"./bodyhombre/piernaderbrazoder.png": 5656,
	"./bodyhombre/piernaderbrazoizq.png": 29674,
	"./bodyhombre/piernaderbrazos.png": 51651,
	"./bodyhombre/piernadernucaposterior.png": 6,
	"./bodyhombre/piernaderposterior.png": 1982,
	"./bodyhombre/piernaizqbrazoder.png": 49394,
	"./bodyhombre/piernaizqbrazoizq copy.png": 83161,
	"./bodyhombre/piernaizqbrazoizq.png": 75451,
	"./bodyhombre/piernaizqbrazos.png": 8789,
	"./bodyhombre/piernaizqnucabrazoder.png": 43752,
	"./bodyhombre/piernaizqnucabrazoizqposterior.png": 74856,
	"./bodyhombre/piernaizqnucaposterior.png": 88774,
	"./bodyhombre/piernaizqposterior.png": 86591,
	"./bodyhombre/piernasbrazoderposterior.png": 88399,
	"./bodyhombre/piernasbrazoizqposterior.png": 98154,
	"./bodyhombre/piernasespalda.png": 58467,
	"./bodyhombre/piernasnucabrazoderposterior.png": 74417,
	"./bodyhombre/piernasnucabrazoizqposterior.png": 44330,
	"./bodyhombre/piernasnucaposterior.png": 95546,
	"./bodyhombre/piernasposterior.png": 35681,
	"./bodyhombre/posterior.png": 74453,
	"./bodyhombre/posteriorcabezaespalda.png": 1160,
	"./bodyhombre/posteriorcabezaespaldabrazoder.png": 49956,
	"./bodyhombre/posteriorcabezaespaldabrazoizq.png": 26916,
	"./bodyhombre/posteriorcabezaespaldapiernader.png": 37377,
	"./bodyhombre/posteriorcabezaespaldapiernaizq.png": 9335,
	"./bodyhombre/posteriormenosbrazoder.png": 20075,
	"./bodyhombre/posteriormenosbrazoizq.png": 28652,
	"./bodyhombre/posteriormenosbrazos.png": 39662,
	"./bodyhombre/posteriormenosespalda.png": 41839,
	"./bodyhombre/torsobrazoder.png": 96031,
	"./bodyhombre/torsobrazoderpiernader.png": 33476,
	"./bodyhombre/torsobrazoderpiernaizq.png": 85860,
	"./bodyhombre/torsobrazoderpiernas.png": 36414,
	"./bodyhombre/torsobrazoizq.png": 16025,
	"./bodyhombre/torsobrazoizqpiernader.png": 43032,
	"./bodyhombre/torsobrazoizqpiernaizq.png": 67239,
	"./bodyhombre/torsobrazoizqpiernas.png": 40905,
	"./bodyhombre/torsocadera.png": 76947,
	"./bodyhombre/torsocaderabrazoder.png": 38627,
	"./bodyhombre/torsocaderabrazoderpiernader.png": 51527,
	"./bodyhombre/torsocaderabrazoderpiernaizq.png": 64883,
	"./bodyhombre/torsocaderabrazoizq.png": 22662,
	"./bodyhombre/torsocaderabrazoizqpiernader.png": 6291,
	"./bodyhombre/torsocaderabrazoizqpiernaizq.png": 81618,
	"./bodyhombre/torsocaderabrazos.png": 10167,
	"./bodyhombre/torsocaderabrazospiernader.png": 73581,
	"./bodyhombre/torsocaderabrazospiernaizq.png": 70320,
	"./bodyhombre/torsocaderabrazospiernas.png": 37536,
	"./bodyhombre/torsocaderapiernader.png": 39925,
	"./bodyhombre/torsocaderapiernaizq.png": 43873,
	"./bodyhombre/torsocaderapiernas.png": 39663,
	"./bodyhombre/torsopiernader.png": 84521,
	"./bodyhombre/torsopiernaizq.png": 3242,
	"./bodyhombre/torsopiernas.png": 27946,
	"./bodymujer/Brazos-001.png": 2771,
	"./bodymujer/Brazos-002.png": 98636,
	"./bodymujer/Brazos-01.png": 1720,
	"./bodymujer/Brazos-02.png": 47267,
	"./bodymujer/Group 275.png": 13606,
	"./bodymujer/Hombros-001.png": 514,
	"./bodymujer/Hombros-01.png": 752,
	"./bodymujer/Manos-001.png": 29732,
	"./bodymujer/Manos-01.png": 50173,
	"./bodymujer/Nuca-001.png": 45702,
	"./bodymujer/Nuca-01.png": 99295,
	"./bodymujer/Pantorrillas-001.png": 53924,
	"./bodymujer/Pantorrillas-01.png": 31955,
	"./bodymujer/Pecho-001.png": 14058,
	"./bodymujer/Pecho-01.png": 69508,
	"./bodymujer/Pelvis-001.png": 793,
	"./bodymujer/Pelvis-01.png": 25389,
	"./bodymujer/Persona.jpg": 16523,
	"./bodymujer/Piernas-001.png": 73792,
	"./bodymujer/Piernas-01.png": 58487,
	"./bodymujer/Pies-001.png": 96379,
	"./bodymujer/Pies-01.png": 1758,
	"./bodymujer/body.png": 400,
	"./bodymujer/bodyNO.png": 57882,
	"./bodymujer/bodyback.png": 18337,
	"./bodymujer/bodybase.png": 45481,
	"./bodymujer/bodybrazoder.png": 14302,
	"./bodymujer/bodybrazoderpiernader.png": 47008,
	"./bodymujer/bodybrazoderpiernaizq.png": 80482,
	"./bodymujer/bodybrazoderpiernas.png": 74706,
	"./bodymujer/bodybrazoizq.png": 80242,
	"./bodymujer/bodybrazoizqpiernader.png": 36696,
	"./bodymujer/bodybrazoizqpiernaizq.png": 92936,
	"./bodymujer/bodybrazoizqpiernas.png": 66211,
	"./bodymujer/bodybrazos.png": 37570,
	"./bodymujer/bodycabeza.png": 19153,
	"./bodymujer/bodycabezacadera.png": 38810,
	"./bodymujer/bodycabezacaderabrazoder.png": 56078,
	"./bodymujer/bodycabezacaderabrazoderpiernader.png": 4312,
	"./bodymujer/bodycabezacaderabrazoderpiernaizq.png": 12515,
	"./bodymujer/bodycabezacaderabrazoderpiernas.png": 88467,
	"./bodymujer/bodycabezacaderabrazoizq.png": 81508,
	"./bodymujer/bodycabezacaderabrazoizqbrazoder.png": 86005,
	"./bodymujer/bodycabezacaderabrazoizqbrazoderpiernader.png": 12514,
	"./bodymujer/bodycabezacaderabrazoizqbrazoderpiernaizq.png": 71584,
	"./bodymujer/bodycabezacaderabrazoizqbrazoderpiernaizqpiernader.png": 56992,
	"./bodymujer/bodycabezacaderabrazoizqpiernader.png": 19443,
	"./bodymujer/bodycabezacaderabrazoizqpiernaizq.png": 77312,
	"./bodymujer/bodycabezacaderabrazoizqpiernas.png": 78646,
	"./bodymujer/bodycabezacaderapiernader.png": 48892,
	"./bodymujer/bodycabezacaderapiernaizq.png": 33486,
	"./bodymujer/bodycabezacaderapiernas.png": 48034,
	"./bodymujer/bodycabezapiernader.png": 122,
	"./bodymujer/bodycabezapiernaizq.png": 50605,
	"./bodymujer/bodycabezapiernas.png": 61540,
	"./bodymujer/bodycabezatorso.png": 87147,
	"./bodymujer/bodycabezatorsobrazoder.png": 4055,
	"./bodymujer/bodycabezatorsobrazoderpiernader.png": 70291,
	"./bodymujer/bodycabezatorsobrazoderpiernaizq.png": 88729,
	"./bodymujer/bodycabezatorsobrazoderpiernas.png": 7688,
	"./bodymujer/bodycabezatorsobrazoizq.png": 75304,
	"./bodymujer/bodycabezatorsobrazoizqpiernader.png": 10840,
	"./bodymujer/bodycabezatorsobrazoizqpiernaizq.png": 52459,
	"./bodymujer/bodycabezatorsobrazoizqpiernas.png": 58825,
	"./bodymujer/bodycabezatorsobrazos.png": 39946,
	"./bodymujer/bodycabezatorsocadera.png": 88687,
	"./bodymujer/bodycabezatorsocaderabrazoder.png": 70816,
	"./bodymujer/bodycabezatorsocaderabrazodermano.png": 70962,
	"./bodymujer/bodycabezatorsocaderabrazodermanopiernaizq.png": 47783,
	"./bodymujer/bodycabezatorsocaderabrazoderqmanopiernader.png": 4401,
	"./bodymujer/bodycabezatorsocaderabrazoizq.png": 66079,
	"./bodymujer/bodycabezatorsocaderabrazoizqmano.png": 7480,
	"./bodymujer/bodycabezatorsocaderabrazoizqmanopiernader.png": 97443,
	"./bodymujer/bodycabezatorsocaderabrazoizqmanopiernaizq.png": 7734,
	"./bodymujer/bodycabezatorsocaderapiernader.png": 48396,
	"./bodymujer/bodycabezatorsocaderapiernaizq.png": 70386,
	"./bodymujer/bodycabezatorsocaderapiernas.png": 63309,
	"./bodymujer/bodycabezatorsopiernader.png": 63873,
	"./bodymujer/bodycabezatorsopiernaizq.png": 2280,
	"./bodymujer/bodycabezatorsopiernas.png": 36226,
	"./bodymujer/bodycadera.png": 69724,
	"./bodymujer/bodycaderapiernader.png": 12996,
	"./bodymujer/bodycaderapiernaizq.png": 36975,
	"./bodymujer/bodycaderapiernas.png": 72164,
	"./bodymujer/bodyespalda.png": 63399,
	"./bodymujer/bodyhombros.png": 85539,
	"./bodymujer/bodymenosbrazoder.png": 79641,
	"./bodymujer/bodymenosbrazoizq.png": 98442,
	"./bodymujer/bodymenoscabeza.png": 73227,
	"./bodymujer/bodymenospiernader.png": 99186,
	"./bodymujer/bodymenospiernaizq.png": 29402,
	"./bodymujer/bodymenospiernas.png": 46784,
	"./bodymujer/bodymenostorso.png": 57446,
	"./bodymujer/bodynuca.png": 61950,
	"./bodymujer/bodynucabrazos.png": 33213,
	"./bodymujer/bodynucabrazospiernader.png": 67946,
	"./bodymujer/bodynucabrazospiernaizq.png": 85966,
	"./bodymujer/bodypiernader.png": 72881,
	"./bodymujer/bodypiernaizq.png": 80237,
	"./bodymujer/bodypiernas.png": 26839,
	"./bodymujer/bodytodo.png": 62176,
	"./bodymujer/bodytorso.png": 41081,
	"./bodymujer/brazos.png": 80178,
	"./bodymujer/brazospelvis.png": 69455,
	"./bodymujer/brazospelvispiernader.png": 13025,
	"./bodymujer/brazospelvispiernaizq.png": 23877,
	"./bodymujer/brazospelvispiernas.png": 7991,
	"./bodymujer/brazospiernader.png": 90097,
	"./bodymujer/brazospiernaizq.png": 41931,
	"./bodymujer/brazosposterior.png": 77386,
	"./bodymujer/brazostorso.png": 39469,
	"./bodymujer/brazostorsopiernader.png": 39043,
	"./bodymujer/brazostorsopiernaizq.png": 5771,
	"./bodymujer/brazostorsopiernas.png": 26967,
	"./bodymujer/cabezabrazoder.png": 6567,
	"./bodymujer/cabezabrazoderpiernader.png": 20843,
	"./bodymujer/cabezabrazoderpiernaizq.png": 19867,
	"./bodymujer/cabezabrazoderpiernas.png": 34335,
	"./bodymujer/cabezabrazoizq.png": 10131,
	"./bodymujer/cabezabrazoizqpiernader.png": 26518,
	"./bodymujer/cabezabrazoizqpiernaizq.png": 6102,
	"./bodymujer/cabezabrazoizqpiernas.png": 76605,
	"./bodymujer/cabezabrazos.png": 1122,
	"./bodymujer/cabezabrazospiernader.png": 62878,
	"./bodymujer/cabezabrazospiernaizq.png": 29156,
	"./bodymujer/cabezabrazospiernas.png": 35769,
	"./bodymujer/derechonucaposterior.png": 95701,
	"./bodymujer/espalda.png": 7667,
	"./bodymujer/espaldabrazoder.png": 61978,
	"./bodymujer/espaldabrazoizq.png": 74199,
	"./bodymujer/espaldabrazos.png": 12018,
	"./bodymujer/espaldabrazosnuca.png": 78744,
	"./bodymujer/espaldabrazosnucapiernader.png": 29354,
	"./bodymujer/espaldabrazosnucapiernaizq.png": 63499,
	"./bodymujer/espaldapiernader.png": 52391,
	"./bodymujer/espaldapiernaderbrazoder.png": 77279,
	"./bodymujer/espaldapiernaderbrazoizq.png": 97909,
	"./bodymujer/espaldapiernaderbrazoizqbrazoder.png": 35531,
	"./bodymujer/espaldapiernaizq.png": 29270,
	"./bodymujer/espaldapiernaizqbrazoder.png": 69991,
	"./bodymujer/espaldapiernaizqbrazoderbrazoizq.png": 72777,
	"./bodymujer/espaldapiernaizqbrazoizq.png": 517,
	"./bodymujer/extremidades.png": 2021,
	"./bodymujer/extremidadescadera.png": 40313,
	"./bodymujer/extremidadesposterior.png": 41887,
	"./bodymujer/extremidadestorso.png": 91087,
	"./bodymujer/izqnucaposterior.png": 56695,
	"./bodymujer/izqposterior.png": 5294,
	"./bodymujer/menoscadera.png": 72294,
	"./bodymujer/menosnucaposterior.png": 80762,
	"./bodymujer/pelvisbrazoder.png": 48245,
	"./bodymujer/pelvisbrazoderpiernader.png": 88844,
	"./bodymujer/pelvisbrazoderpiernaizq.png": 41516,
	"./bodymujer/pelvisbrazoderpiernas.png": 60498,
	"./bodymujer/pelvisbrazoderpiernastorso.png": 39922,
	"./bodymujer/pelvisbrazoizq.png": 59456,
	"./bodymujer/pelvisbrazoizqpiernader.png": 54130,
	"./bodymujer/pelvisbrazoizqpiernaizq.png": 72313,
	"./bodymujer/pelvisbrazoizqpiernas.png": 55248,
	"./bodymujer/pelvisbrazoizqpiernastorso.png": 18412,
	"./bodymujer/piernaderbrazoder.png": 21929,
	"./bodymujer/piernaderbrazoizq.png": 42323,
	"./bodymujer/piernaderbrazos.png": 3602,
	"./bodymujer/piernadernucaposterior.png": 55731,
	"./bodymujer/piernaderposterior.png": 23753,
	"./bodymujer/piernaizqbrazoder.png": 2828,
	"./bodymujer/piernaizqbrazoizq copy.png": 2894,
	"./bodymujer/piernaizqbrazoizq.png": 11887,
	"./bodymujer/piernaizqbrazos.png": 16696,
	"./bodymujer/piernaizqnucabrazoder.png": 24128,
	"./bodymujer/piernaizqnucabrazoizqposterior.png": 8303,
	"./bodymujer/piernaizqnucaposterior.png": 67824,
	"./bodymujer/piernaizqposterior.png": 39715,
	"./bodymujer/piernasbrazoderposterior.png": 97217,
	"./bodymujer/piernasbrazoizqposterior.png": 57242,
	"./bodymujer/piernasespalda.png": 78490,
	"./bodymujer/piernasnucabrazoderposterior.png": 16649,
	"./bodymujer/piernasnucabrazoizqposterior.png": 94251,
	"./bodymujer/piernasnucaposterior.png": 19281,
	"./bodymujer/piernasposterior.png": 39137,
	"./bodymujer/posterior.png": 42051,
	"./bodymujer/posteriorcabezaespalda.png": 69183,
	"./bodymujer/posteriorcabezaespaldabrazoder.png": 7580,
	"./bodymujer/posteriorcabezaespaldabrazoizq.png": 6269,
	"./bodymujer/posteriorcabezaespaldapiernader.png": 90422,
	"./bodymujer/posteriorcabezaespaldapiernaizq.png": 73971,
	"./bodymujer/posteriormenosbrazoder.png": 67171,
	"./bodymujer/posteriormenosbrazoizq.png": 51242,
	"./bodymujer/posteriormenosbrazos.png": 9156,
	"./bodymujer/posteriormenosespalda.png": 74798,
	"./bodymujer/torsobrazoder.png": 46543,
	"./bodymujer/torsobrazoderpiernader.png": 76530,
	"./bodymujer/torsobrazoderpiernaizq.png": 81874,
	"./bodymujer/torsobrazoderpiernas.png": 83590,
	"./bodymujer/torsobrazoizq.png": 37794,
	"./bodymujer/torsobrazoizqpiernader.png": 23773,
	"./bodymujer/torsobrazoizqpiernaizq.png": 69902,
	"./bodymujer/torsobrazoizqpiernas.png": 5413,
	"./bodymujer/torsocadera.png": 27567,
	"./bodymujer/torsocaderabrazoder.png": 31593,
	"./bodymujer/torsocaderabrazoderpiernader.png": 66957,
	"./bodymujer/torsocaderabrazoderpiernaizq.png": 49143,
	"./bodymujer/torsocaderabrazoizq.png": 16236,
	"./bodymujer/torsocaderabrazoizqpiernader.png": 66037,
	"./bodymujer/torsocaderabrazoizqpiernaizq.png": 2223,
	"./bodymujer/torsocaderabrazos.png": 74326,
	"./bodymujer/torsocaderabrazospiernader.png": 29946,
	"./bodymujer/torsocaderabrazospiernaizq.png": 31929,
	"./bodymujer/torsocaderabrazospiernas.png": 86474,
	"./bodymujer/torsocaderapiernader.png": 85290,
	"./bodymujer/torsocaderapiernaizq.png": 76137,
	"./bodymujer/torsocaderapiernas.png": 54099,
	"./bodymujer/torsopiernader.png": 39668,
	"./bodymujer/torsopiernaizq.png": 17511,
	"./bodymujer/torsopiernas.png": 23511,
	"./doc.png": 39171,
	"./easi-brazos.png": 6197,
	"./easi-cabeza.png": 67843,
	"./easi-limpio.png": 85236,
	"./easi-piernas.png": 40314,
	"./easi-tronco.png": 22934,
	"./logoasoderm.jpg": 23866,
	"./more.png": 47018,
	"./more@2x.png": 28188,
	"./more@3x.png": 923,
	"./next.png": 60913,
	"./reporte/easi-brazos.png": 41798,
	"./reporte/easi-cabeza.png": 97694,
	"./reporte/easi-piernas.png": 9566,
	"./reporte/easi-tronco.png": 24232,
	"./tipseasy.png": 86093,
	"./tipseasy2.png": 53219,
	"./tipsscorad1.png": 21489,
	"./tipsscorad2.png": 90375,
	"./tipsscorad3.png": 97188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;